import { PropertyManagementSystem } from "types/landlord/partner";

// Is PMS is any other -> we treat partner as MANUAL
export const SupportedPropertyManagementSystem = [
  PropertyManagementSystem.APPFOLIO,
  PropertyManagementSystem.BUILDIUM,
  PropertyManagementSystem.ENTRATA,
  PropertyManagementSystem.MANAGE_AMERICA,
  PropertyManagementSystem.QUEXT,
  PropertyManagementSystem.RENT_MANAGER,
  PropertyManagementSystem.RENTERS_WAREHOUSE,
  PropertyManagementSystem.RENTVINE,
  PropertyManagementSystem.RESMAN,
  PropertyManagementSystem.YARDI
];
